import React, { useMemo, useState } from 'react';
import { connect } from "react-redux";
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { SelectBox } from 'devextreme-react/select-box';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert } from 'devextreme/ui/dialog';

const TransactionProfile = ({ visible, onClose, accessToken, onGridRefresh, onProfileApply }) => {
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [selectedProfileData, setSelectedProfileData] = useState(null);

    const profileDataSource = useMemo(() => {
        return new DataSource({
            store: createStore({
                key: 'RowId',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/TransManagementDp/GetTransManagementDps`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
    }, [accessToken]);

    const handleClose = () => {
        setSelectedProfile(null);
        setSelectedProfileData(null);
        if (onClose) onClose();
    };

    const handleOk = () => {
        if (!selectedProfile) {
            alert("Please select a profile.", "Warning");
            return;
        }
        if (onProfileApply) onProfileApply(selectedProfileData);
        if (onGridRefresh) onGridRefresh();
        handleClose();
    };

    return (
        <Popup
            visible={visible}
            onHiding={handleClose}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title="Select Transaction Profile"
            width={500}
            height={250}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ flex: 1, padding: '15px' }}>
                    <SelectBox
                        dataSource={profileDataSource}
                        valueExpr="RowId"
                        displayExpr="ProfileCode"
                        value={selectedProfile}
                        onValueChanged={(e) => setSelectedProfile(e.value)}
                        onSelectionChanged={(e) => setSelectedProfileData(e.selectedItem)}
                        searchEnabled={true}
                        searchMode="contains"
                        label="Profile"
                        labelMode="static"
                        stylingMode="outlined"
                        placeholder="Select a profile..."
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                    <Button text="Ok" type="default" icon="check" onClick={handleOk} />
                    <Button text="Cancel" type="normal" icon="close" onClick={handleClose} />
                </div>
            </div>
        </Popup>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(TransactionProfile);
